"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const EventEmitter = require("wolfy87-eventemitter");
const LogManager_1 = require("../Log/LogManager");
const TypeScriptUtils_1 = require("../Common/TypeScriptUtils");
const DomainCommandHandler_1 = require("../Engine/Command/DomainCommandHandler");
const IEventHub_1 = require("../Engine/Event/IEventHub");
const DomainEventHandler_1 = require("../Engine/Event/DomainEventHandler");
const UserEvent_1 = require("./UserEvent");
const UserCommand_1 = require("./UserCommand");
const RtcCommand_1 = require("../Engine/Command/RtcCommand");
const User_1 = require("./User");
const CommonBaseError_1 = require("../Common/CommonBaseError");
const UserDto_1 = require("./Protocol/UserDto");
const InitialState_1 = require("./InitialState");
const ProtocolConstant_1 = require("../Protocol/ProtocolConstant");
const Contact_1 = require("./Contact");
class UserClientApplicationService {
    constructor(l, ur, cmdHub, evtHub) {
        this._logger = LogManager_1.logManager.GetLogger("UserClientApplicationService");
        this._localUserId = "";
        this.errorOccurred = new EventEmitter();
        this._langyan = l;
        this._userRepo = ur;
        this._cmdHub = cmdHub;
        this._evtHub = evtHub;
        this._commandHandler = new DomainCommandHandler_1.DomainCommandHandler(UserCommand_1.UserCommand.Category, this._logger, cmdHub);
        this._commandHandler.registerAsyncCommandHandler(UserCommand_1.UserCommand.FetchAllUser, async (c) => this.onFetchAllUser(c));
        this._commandHandler.registerAsyncCommandHandler(UserCommand_1.UserCommand.FetchUser, async (c) => this.onFetchUser(c));
        this._eventHandler = new DomainEventHandler_1.DomainEventHandler(UserEvent_1.UserEvent.Category, this._logger);
    }
    async initAsync(userDto) {
        const user = User_1.User.Builder(this._userRepo, this._cmdHub, this._evtHub)
            .id(userDto.id)
            .username(userDto.username)
            .displayName(userDto.displayname)
            .avatar(userDto.avatar)
            .isOnline(true)
            .build();
        this._cmdHub.errorOccurred.addListener(UserCommand_1.UserCommand.Category, (error) => this.reportError(error));
        this._evtHub.errorOccurred.addListener(UserEvent_1.UserEvent.Category, (error) => this.reportError(error));
        this._cmdHub.registerCommandHandler(UserCommand_1.UserCommand.Category, this);
        this._evtHub.registerEventHandler(UserEvent_1.UserEvent.Category, this);
        // 一開始先存本地User，等連上WebSync回傳本地User的最新狀態再換掉
        await this._userRepo.saveAsync(user);
        this._localUserId = user.id;
        // Subscribe first channel, receiving InitialState
        const initialStateObj = await this._langyan.subscribeAsync(UserClientApplicationService.GetInitChannelName(userDto.username), this.InitChannelHandler);
        const initialState = new InitialState_1.InitialState(initialStateObj);
        await this.ProcessInitialState(initialState);
    }
    async terminateAsync() {
        await this._langyan.unSubscribeAsync(UserClientApplicationService.GetInitChannelName(this.LocalUser.username));
        this._evtHub.unRegisterEventHandler(UserEvent_1.UserEvent.Category);
        this._cmdHub.unRegisterCommandHandler(UserCommand_1.UserCommand.Category);
        this._evtHub.errorOccurred.removeListener(UserEvent_1.UserEvent.Category, this.reportError);
        this._cmdHub.errorOccurred.removeListener(UserCommand_1.UserCommand.Category, this.reportError);
        await this.clearAllLocalData();
        this.errorOccurred.removeAllListeners();
    }
    handleCommand(cmd) {
        this._commandHandler.handleCommand(cmd);
    }
    async handleCommandAsync(cmd) {
        if (cmd.targetId) {
            const liveId = cmd.targetId;
            const user = await this._userRepo.userOfIdAsync(liveId);
            if (user !== User_1.User.INVALID_USER) {
                await user.handleCommandAsync(cmd);
                return;
            }
        }
        await this._commandHandler.handleCommandAsync(cmd);
    }
    handleEvent(e) {
        if (e.isLocal)
            return;
        if (e.entityId) {
            const user = this._userRepo.userOfId(e.entityId);
            if (user !== User_1.User.INVALID_USER) {
                user.handleEvent(e);
                return;
            }
        }
        this._eventHandler.handleEvent(e);
    }
    async handleEventAsync(e) {
        if (e.isLocal)
            return;
        if (e.entityId) {
            const user = await this._userRepo.userOfIdAsync(e.entityId);
            if (user !== User_1.User.INVALID_USER) {
                await user.handleEventAsync(e);
                return;
            }
        }
        await this._eventHandler.handleEventAsync(e);
    }
    async TranslatePublishedDomainEventToEventHander(e) {
        if (e.category !== UserEvent_1.UserEvent.Category) {
            this._logger.warn(`Wrong category=${e.category}, event is not public to client.`);
            return;
        }
        //不處理遠端送過來的Event，只處理本地端UserDomain送出來的Event
        //因為遠端的Event要先進本地UserDomain處理
        if (!e.isLocal)
            return;
        // switch (e.name) {
        //   case UserEvent.UserIsOnline:
        //   case UserEvent.UserIsOffline:
        //   case UserEvent.UserStatusUpdated:
        //     if (NewUserStatus != null) {
        //       const userFromEvent = e.BodyTo<UserDto>();
        //       NewUserStatus(this, userFromEvent);
        //     }
        //     break;
        //   case UserEvent.ContactBecameFavorite:
        //     if (ContactFavoriteStatusChanged != null) {
        //       const contact = e.BodyTo<Contact>();
        //       ContactFavoriteStatusChanged(this, Tuple.Create(contact, true));
        //     }
        //     break;
        //   case UserEvent.ContactBecameNotFavorite:
        //     if (ContactFavoriteStatusChanged != null) {
        //       const contact = e.BodyTo<Contact>();
        //       ContactFavoriteStatusChanged(this, Tuple.Create(contact, false));
        //     }
        //     break;
        // }
    }
    subscribeEventHandler(eventName, onEventHandler) {
        return this._evtHub.subscribeEventHandler(UserEvent_1.UserEvent.Category, eventName, onEventHandler, (err) => this.reportError(err));
    }
    subscribeEventAsyncHandler(eventName, onEventHandler) {
        return this._evtHub.subscribeEventAsyncHandler(UserEvent_1.UserEvent.Category, eventName, onEventHandler, (err) => this.reportError(err));
    }
    static GetInitChannelName(username) {
        return `${ProtocolConstant_1.RTC_CHATTING_CHAT_CHANNEL_NAME}/${username}`;
    }
    async InitChannelHandler(cm) {
        return;
    }
    get LocalUser() {
        const user = this._userRepo.userOfId(this._localUserId);
        if (user === User_1.User.INVALID_USER)
            throw new UserApplicationServiceError("No local user, connection is not established.");
        return user.toUserDto();
    }
    async ProcessInitialState(initialState) {
        //this._logger.debug(`Get initialState = ${initialState}`);
        this._logger.debug(`Get initialState`);
        // Update self
        const selfUserDto = initialState.user;
        this._logger.debug(`user=${selfUserDto.username} isOnline=${selfUserDto.isOnline}`);
        const selfUser = User_1.User.Builder(this._userRepo, this._cmdHub, this._evtHub)
            .id(selfUserDto.id)
            .username(selfUserDto.username)
            .displayName(selfUserDto.displayname)
            .isOnline(true)
            .avatar(selfUserDto.avatar)
            .contacts(selfUserDto.contacts.map(c => new Contact_1.Contact(c)))
            .build();
        await this._userRepo.saveAsync(selfUser);
        const user = await this._userRepo.userOfIdAsync(selfUser.id);
        await this.notifyNewUserStatusAsync(user.toUserDto());
        // Update contacts
        for (let i = 0; i < initialState.friends.length; i++) {
            // set the user statuses
            const contactDto = initialState.friends[i];
            const contactUser = User_1.User.Builder(this._userRepo, this._cmdHub, this._evtHub)
                .id(contactDto.id)
                .username(contactDto.username)
                .displayName(contactDto.displayname)
                .isOnline(contactDto.isOnline)
                .avatar(contactDto.avatar)
                .contacts(contactDto.contacts)
                .build();
            await this._userRepo.saveAsync(contactUser);
        }
    }
    userOfId(userId) {
        const result = this.Execute(() => {
            return this._userRepo.userOfId(userId).toUserDto();
        }, UserDto_1.UserDto.INVALID_USER);
        return result;
    }
    async userOfIdAsync(userId) {
        const result = await this.ExecuteAsync(async () => {
            const user = await this._userRepo.userOfIdAsync(userId);
            return user.toUserDto();
        }, UserDto_1.UserDto.INVALID_USER);
        return result;
    }
    findUserByName(username) {
        const result = this.Execute(() => {
            const user = this._userRepo.userOfName(username);
            return user.toUserDto();
        }, UserDto_1.UserDto.INVALID_USER);
        return result;
    }
    doesUserNameExist(username) {
        const result = this.Execute(() => {
            return this._userRepo.exists(username);
        }, false);
        return result;
    }
    async addContactAsync(contactUserDto) {
        await this.ExecuteAsync(async () => {
            const localUser = await this._userRepo.userOfIdAsync(this._localUserId);
            const contact = new Contact_1.Contact({
                id: contactUserDto.id,
                name: contactUserDto.username,
                displayName: contactUserDto.displayname,
                avatar: contactUserDto.avatar,
            });
            await localUser.AddContactAsync(contact);
        });
    }
    async hideContactAsync(contactUserDto) {
        await this.ExecuteAsync(async () => {
            const localUser = await this._userRepo.userOfIdAsync(this._localUserId);
            const contact = new Contact_1.Contact({
                id: contactUserDto.id,
                name: contactUserDto.username,
                displayName: contactUserDto.displayname,
                avatar: contactUserDto.avatar,
            });
            await localUser.HideContactAsync(contact);
        });
    }
    async blockContactAsync(contactUserDto) {
        await this.ExecuteAsync(async () => {
            const localUser = await this._userRepo.userOfIdAsync(this._localUserId);
            const contact = new Contact_1.Contact({
                id: contactUserDto.id,
                name: contactUserDto.username,
                displayName: contactUserDto.displayname,
                avatar: contactUserDto.avatar,
            });
            await localUser.BlockContactAsync(contact);
        });
    }
    async recoverContactAsync(contactUserDto) {
        await this.ExecuteAsync(async () => {
            const localUser = await this._userRepo.userOfIdAsync(this._localUserId);
            const contact = new Contact_1.Contact({
                id: contactUserDto.id,
                name: contactUserDto.username,
                displayName: contactUserDto.displayname,
                avatar: contactUserDto.avatar,
            });
            await localUser.RecoverContactAsync(contact);
        });
    }
    async removeContactAsync(contactUserDto) {
        await this.ExecuteAsync(async () => {
            const localUser = await this._userRepo.userOfIdAsync(this._localUserId);
            const contact = new Contact_1.Contact({
                id: contactUserDto.id,
                name: contactUserDto.username,
                displayName: contactUserDto.displayname,
                avatar: contactUserDto.avatar,
            });
            await localUser.RemoveContactAsync(contact);
        });
    }
    async fetchNewContactStatusAsync() {
        await this.ExecuteAsync(async () => {
            const localUser = this._userRepo.userOfId(this._localUserId);
            await localUser.FetchContactStatusAsync();
        });
    }
    async addContactToFavoriteAsync(contactUserDto) {
        await this.ExecuteAsync(async () => {
            const localUser = await this._userRepo.userOfIdAsync(this._localUserId);
            const contact = new Contact_1.Contact({
                id: contactUserDto.id,
                name: contactUserDto.username,
                displayName: contactUserDto.displayname,
                avatar: contactUserDto.avatar,
            });
            await localUser.AddContactToFavoriteAsync(contact);
        });
    }
    async removeContactFromFavoriteAsync(contactUserDto) {
        await this.ExecuteAsync(async () => {
            const localUser = await this._userRepo.userOfIdAsync(this._localUserId);
            const contact = new Contact_1.Contact({
                id: contactUserDto.id,
                name: contactUserDto.username,
                displayName: contactUserDto.displayname,
                avatar: contactUserDto.avatar,
            });
            await localUser.RemoveContactFromFavoriteAsync(contact);
        });
    }
    async requestFetchAllUser() {
        await this.ExecuteAsync(async () => {
            const cmd = UserCommand_1.UserCommand.FetchAllUserRequestExecuteCommand();
            await this._cmdHub.sendCommandAsync(cmd);
        });
    }
    async onFetchAllUser(rtcCmd) {
        switch (rtcCmd.type) {
            case RtcCommand_1.CmdType.ResponseAccept:
                const fetchedUsers = rtcCmd.contentTo();
                for (const userObj of fetchedUsers) {
                    const user = new UserDto_1.UserDto(userObj);
                    await this.notifyNewUserStatusAsync(user);
                }
                break;
            case RtcCommand_1.CmdType.ResponseFail:
                break;
        }
    }
    async fetchUserByNameAsync(username) {
        await this.ExecuteAsync(async () => {
            const cmd = UserCommand_1.UserCommand.FetchUserCommand(new TypeScriptUtils_1.Tuple2({
                Item1: "",
                Item2: username
            }));
            await this._cmdHub.sendCommandAsync(cmd);
        });
    }
    async onFetchUser(rtcCmd) {
        switch (rtcCmd.type) {
            case RtcCommand_1.CmdType.ResponseAccept:
                //收到新User更新一下
                const fetchedUserDto = rtcCmd.contentTo();
                const fetchedUser = User_1.User.Builder(this._userRepo, this._cmdHub, this._evtHub)
                    .id(fetchedUserDto.id)
                    .username(fetchedUserDto.username)
                    .displayName(fetchedUserDto.displayname)
                    .isOnline(fetchedUserDto.isOnline)
                    .avatar(fetchedUserDto.avatar)
                    .contacts(fetchedUserDto.contacts)
                    .build();
                await this._userRepo.saveAsync(fetchedUser);
                await this.notifyNewUserStatusAsync(fetchedUser.toUserDto());
                break;
            case RtcCommand_1.CmdType.ResponseFail:
                this._logger.error(`Execute RtcCommand failed. ${rtcCmd}`);
                break;
            default:
                break;
        }
    }
    async clearAllLocalData() {
        await this.ExecuteAsync(async () => {
            await this._userRepo.clearAsync();
        });
    }
    async notifyNewUserStatusAsync(user) {
        this._logger.debug(`Updating new user status: ${user.username}, Online=${user.isOnline}`);
        const userStatusUpdatedEvt = UserEvent_1.UserEvent.UserStatusUpdatedEvent(user);
        this._evtHub.publishAsync(userStatusUpdatedEvt, [IEventHub_1.EventReceiver.CLIENT]);
    }
    async ExecuteAsync(operation, defaultReturnValue = {}, memberName = "") {
        try {
            const localUser = this.LocalUser;
            if (localUser === UserDto_1.UserDto.INVALID_USER)
                throw new UserApplicationServiceError("local user should be valid user");
            return await operation();
        }
        catch (err) {
            const errorMsg = `${memberName || ""}: ${err.message}`;
            const appServiceError = new UserApplicationServiceError(errorMsg, err);
            this.reportError(appServiceError);
            return defaultReturnValue;
        }
    }
    Execute(operation, defaultReturnValue = {}, memberName = "") {
        try {
            const localUser = this.LocalUser;
            if (localUser === UserDto_1.UserDto.INVALID_USER)
                throw new UserApplicationServiceError("local user should be valid user");
            return operation();
        }
        catch (err) {
            const errorMsg = `${memberName || ""}: ${err.message}`;
            const appServiceError = new UserApplicationServiceError(errorMsg, err);
            this.reportError(appServiceError);
            return defaultReturnValue;
        }
    }
    reportError(error) {
        try {
            const userAppServiceError = (error instanceof UserApplicationServiceError) ? error : new UserApplicationServiceError(error.message, error);
            this.errorOccurred.emitEvent(exports.UserApplicationServiceErrorName, [userAppServiceError]);
        }
        catch (e) {
            // Prevent outside error handler throwing error again.
            this._logger.error(e.message, e);
        }
    }
}
exports.UserClientApplicationService = UserClientApplicationService;
exports.UserApplicationServiceErrorName = "UserApplicationServiceError";
class UserApplicationServiceError extends CommonBaseError_1.CommonBaseError {
}
exports.UserApplicationServiceError = UserApplicationServiceError;
//# sourceMappingURL=UserClientApplicationService.js.map